<template>
  <div>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-row :gutter="20">
        <el-col :span="4">
          <el-button type="primary" @click="addDialogVisible = true">新增快捷回复</el-button>
        </el-col>
      </el-row>

      <!-- 标签列表区域 -->
      <el-table :data="postlist" border stripe>
        <el-table-column label="编号" type="index"></el-table-column>
        <el-table-column label="话术" prop="Content"></el-table-column>
        <el-table-column label="类型" prop="Type" width="160px">
          <template v-slot="{ row }">
            {{ TypeList[row.Type] }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100px">
          <template slot-scope="scope">
            <template v-if="0">
              <!-- 修改按钮 -->
              <el-tooltip effect="dark" content="修改" placement="top" :enterable="false">
                <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row)"></el-button>
              </el-tooltip>
            </template>
            <!-- 删除按钮 -->
            <el-button type="danger" size="mini" @click="removePostById(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination v-if="0" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum" :page-sizes="[1,10, 20, 50]" :page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

    <!-- 添加标签的对话框 -->
    <el-dialog title="添加标签" :visible.sync="addDialogVisible" width="500px" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="90px">
        <el-form-item label="话术" prop="content">
          <el-input type="textarea" :autosize="{  minRows: 4 }" v-model="addForm.content"  placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addPost">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改标签的对话框 -->
    <el-dialog title="修改标签" :visible.sync="editDialogVisible" width="500px" @close="editDialogClosed">
      <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="90px">
        <el-form-item label="话术" prop="Content">
          <el-input type="textarea" :autosize="{  minRows: 4 }" v-model="editForm.Content" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editPostInfo">确 定</el-button>
      </span>
    </el-dialog>
   </div>
</template>

<script>
  import { chat_del, chat_get, chat_post, toForm } from '@/api'
  export default {
    data() {
      return {
        // 获取标签列表的参数对象
        queryInfo: {
          status: 1,
          pagenum: 1,
          pagesize: 10
        },
        postlist: [],
        total: 0,
        // 控制添加标签对话框的显示与隐藏
        addDialogVisible: false,
        // 添加标签的表单数据
        addForm: {
          content: '',
          type: 1
        },
        TypeList: {
          '0': '自定义',
          '1': '系统话术'
        },
        // 添加表单的验证规则对象
        addFormRules: {
          content: [
            { required: true, message: '请输入内容', trigger: 'blur' }
          ]
        },
        // 控制修改标签对话框的显示与隐藏
        editDialogVisible: false,
        // 查询到的标签信息对象
        editForm: {
          Content: '',
          type: 1
        },
        // 修改表单的验证规则对象
        editFormRules: {
          Content: [
            { required: true, message: '请输入内容', trigger: 'blur' }
          ]
        }
      }
    },
    created() {
      this.getPostList()
    },
    methods: {
      getPostList() {
        chat_get(`/admin/v1/QuickReply?size=${this.queryInfo.pagesize}&page=${this.queryInfo.pagenum}&status=${this.queryInfo.status}`, {}, res => {
          if(res.status == 200) {
            this.postlist = res.data.MessageContent
            // let { List: postList, Total } = res.data.MessageContent
            // this.total = Total
            // this.postlist = postList
          }
        })
      },
      // 监听 pagesize 改变的事件
      handleSizeChange(newSize) {
        this.queryInfo.pagesize = newSize
        this.getPostList()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange(newPage) {
        this.queryInfo.pagenum = newPage
        this.getPostList()
      },
      // 监听添加标签对话框的关闭事件
      addDialogClosed() {
        this.$refs.addFormRef.resetFields()
      },
      // 点击按钮，添加新标签
      addPost() {
        let params = toForm(this.addForm)
        this.$refs.addFormRef.validate(valid => {
          if (!valid) return
          chat_post('/admin/v1/QuickReply', params, res => {
            if(res.status == 200) {
              this.$message.success('添加成功！')
              // 隐藏添加标签的对话框
              this.addDialogVisible = false
              // 重新获取标签列表数据
              this.getPostList()
            }
          })
        })
      },
      // 展示编辑标签的对话框
      showEditDialog(row) {
        this.editForm = {
          ...row
        }
        this.editDialogVisible = true
      },
      // 监听修改标签对话框的关闭事件
      editDialogClosed() {
        this.$refs.editFormRef.resetFields()
      },
      // 修改标签信息并提交
      editPostInfo() {
        this.$refs.editFormRef.validate(valid => {
          if (!valid) return
          console.log(this.editForm)
          let {PostCode,PostName, PostSort, Status, Remark, Id} = this.editForm
          let params = toForm({
            postCode: PostCode,
            postName: PostName,
            postSort: PostSort,
            status: Status,
            remark: Remark,
            id: Id
          })
          chat_post('/admin/v1/upTag', params, res => {
            if(res.status == 200) {
              // 关闭对话框
              this.editDialogVisible = false
              // 刷新数据列表
              this.getPostList()
              // 提示修改成功
              this.$message.success('更新标签信息成功！')
            }
          })
        })
      },
      // 根据Id删除对应的标签信息
      removePostById(oneUser) {
        let vm = this;
        this.$confirm( `此操作将删除该话术, 是否继续?`, '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          chat_del(`/admin/v1/QuickReply/${oneUser.Id}`, {}, res => {
            if(res.status == 200) {
              vm.getPostList()
              vm.$message({
                type: 'success',
                message: `删除成功!`
              });
            }
          })
        }).catch(() => {
          oneUser.Status = !oneUser.Status
        });
      },
    }
  }
</script>

<style lang="less" scoped>
</style>
